/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAccountGetResponseFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeAccountPatchRequest, type AccountGetResponse, type AccountPatchRequest, type ProblemDetails } from '../../models';
// @ts-ignore
import { BalanceRequestBuilderRequestsMetadata, type BalanceRequestBuilder } from './balance';
// @ts-ignore
import { CycleRequestBuilderRequestsMetadata, type CycleRequestBuilder } from './cycle';
// @ts-ignore
import { PastRequestBuilderRequestsMetadata, type PastRequestBuilder } from './past';
// @ts-ignore
import { SplitsRequestBuilderNavigationMetadata, SplitsRequestBuilderRequestsMetadata, type SplitsRequestBuilder } from './splits';
// @ts-ignore
import { type UpcomingcyclesRequestBuilder, UpcomingcyclesRequestBuilderRequestsMetadata } from './upcomingcycles';
// @ts-ignore
import { type UpcomingtransactionsRequestBuilder, UpcomingtransactionsRequestBuilderNavigationMetadata } from './upcomingtransactions';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{accountId}
 */
export interface WithAccountItemRequestBuilder extends BaseRequestBuilder<WithAccountItemRequestBuilder> {
    /**
     * The balance property
     */
    get balance(): BalanceRequestBuilder;
    /**
     * The cycle property
     */
    get cycle(): CycleRequestBuilder;
    /**
     * The past property
     */
    get past(): PastRequestBuilder;
    /**
     * The splits property
     */
    get splits(): SplitsRequestBuilder;
    /**
     * The upcomingcycles property
     */
    get upcomingcycles(): UpcomingcyclesRequestBuilder;
    /**
     * The upcomingtransactions property
     */
    get upcomingtransactions(): UpcomingtransactionsRequestBuilder;
    /**
     * Deletes an account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Retrieves a specific account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AccountGetResponse>}
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AccountGetResponse | undefined>;
    /**
     * Updates an account
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     patch(body: AccountPatchRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Deletes an account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Retrieves a specific account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Updates an account
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPatchRequestInformation(body: AccountPatchRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithAccountItemRequestBuilderUriTemplate = "{+baseurl}/accounts/{accountId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithAccountItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithAccountItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    balance: {
        requestsMetadata: BalanceRequestBuilderRequestsMetadata,
    },
    cycle: {
        requestsMetadata: CycleRequestBuilderRequestsMetadata,
    },
    past: {
        requestsMetadata: PastRequestBuilderRequestsMetadata,
    },
    splits: {
        requestsMetadata: SplitsRequestBuilderRequestsMetadata,
        navigationMetadata: SplitsRequestBuilderNavigationMetadata,
    },
    upcomingcycles: {
        requestsMetadata: UpcomingcyclesRequestBuilderRequestsMetadata,
    },
    upcomingtransactions: {
        navigationMetadata: UpcomingtransactionsRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithAccountItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithAccountItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: WithAccountItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createAccountGetResponseFromDiscriminatorValue,
    },
    patch: {
        uriTemplate: WithAccountItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAccountPatchRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
